import React from 'react';
import ErrorLayout from '../ErrorLayout';

const NotFound = () => (
    <ErrorLayout code={404} message="La página que busca no esta disponible" />
);

export default NotFound;
